<ng-template #templateRef let-ctx="dialogRef.context">
  <div class="dialog-wrapper" [attr.data-e2e-id]="dialogE2eId">
    <header
      *ngIf="headerLabel || !hideCloseButton"
      class="dialog-header"
      [ngClass]="{ 'has-label': headerLabel }"
    >
      <span *ngIf="headerLabel" class="header-label">
        {{ headerLabel }}
      </span>

      <button
        *ngIf="!hideCloseButton"
        class="{{ ctx.closeClassName }} close-action"
        data-e2e-id="close-dialog-action"
        trackable
        [trackingObject]="trackingObject || defaultTrackingObject"
        [trackingAction]="dismissActionTapped || defaultDismissTapped"
        [trackingAdditionalProperties]="
          dismissActionTrackingAdditionalProperties
        "
        (click)="closeAction()"
      >
        <app-icon [icon]="closeIcon"></app-icon>
      </button>
    </header>

    <div class="dialog-content">
      <div class="custom-content">
        <ng-content></ng-content>

        <div
          *ngIf="footerText"
          class="footer"
          [innerHTML]="htmlFooter ? (footerText | safe: 'html') : footerText"
        ></div>

        <div
          *ngIf="actionLeadText"
          class="action-lead"
          [innerHTML]="
            htmlActionLead ? (actionLeadText | safe: 'html') : actionLeadText
          "
        ></div>
      </div>

      <div
        *ngIf="!hideActions"
        [ngClass]="{
          'center-actions': centerActions,
          'stack-actions': stackActions
        }"
        class="dialog-actions"
      >
        <button
          type="button"
          class="action primary-action"
          [ngClass]="{ 'destroying-action': isPrimaryActionDestroying }"
          data-e2e-id="primary-dialog-action"
          [disabled]="primaryActionDisabled"
          trackable
          [trackingObject]="trackingObject || defaultTrackingObject"
          [trackingAction]="primaryActionTapped || defaultCta1Tapped"
          [trackingAdditionalProperties]="
            primaryActionTrackingAdditionalProperties
          "
          [innerHTML]="
            htmlPrimaryAction
              ? (primaryActionText | safe: 'html')
              : primaryActionText || ('ACTION.OK' | translate)
          "
          (click)="primaryAction()"
        ></button>

        <button
          *ngIf="secondaryActionText"
          type="button"
          class="action secondary-action"
          [ngClass]="{ 'destroying-action': isSecondaryActionDestroying }"
          data-e2e-id="secondary-dialog-action"
          [disabled]="secondaryActionDisabled"
          trackable
          [trackingObject]="trackingObject || defaultTrackingObject"
          [trackingAction]="secondaryActionTapped || defaultCta2Tapped"
          [trackingAdditionalProperties]="
            secondaryActionTrackingAdditionalProperties
          "
          [innerHTML]="
            htmlSecondaryAction
              ? (secondaryActionText | safe: 'html')
              : secondaryActionText
          "
          (click)="secondaryAction()"
        ></button>
      </div>
    </div>
  </div>
</ng-template>
